import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import styles from './DropdownDisplayTime.module.scss';

//https://github.com/iannbing/react-simple-tree-menu
//react-simple-tree-menu

export default DropdownDisplayTime;

function DropdownDisplayTime({ currentMode, onSelectionChangedCallback }) {
  const { t } = useTranslation();

  // Set initial dropdown value based on currentMode prop
  const getDropdownValueForMode = (mode) => {
    return mode === 0 ? t('recordView.multiChart.displayTime.fromZero') : t('recordView.multiChart.displayTime.actual');
  };

  const [dropDownValue, setDropDownValue] = useState(getDropdownValueForMode(currentMode || 0));

  // Update dropdown value when currentMode prop changes
  useEffect(() => {
    setDropDownValue(getDropdownValueForMode(currentMode || 0));
  }, [currentMode, t]);

  const onSelectionChanged = function (eventKey) {
    //setValue(eventKey);

    if (onSelectionChangedCallback) {
      let mode = eventKey === "10" ? 0 : 1;
      onSelectionChangedCallback(mode);
    }
  }

  return (   
    <>
      <div className="text-nowrap">
        <label>{t('recordView.multiChart.displayTime.header')}:</label>
        <Dropdown onSelect={(eventKey) => { onSelectionChanged(eventKey) }} className="d-inline px-2">
          <Dropdown.Toggle variant={`primary ${styles.dropDown}`} id="dropdown-basic">{dropDownValue}</Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item eventKey="10"><div onClick={(e) => setDropDownValue(e.target.textContent)}>{t('recordView.multiChart.displayTime.fromZero')}</div></Dropdown.Item>
            <Dropdown.Item eventKey="20"><div onClick={(e) => setDropDownValue(e.target.textContent)}>{t('recordView.multiChart.displayTime.actual')}</div></Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>        
      </div>
    </>
  );
}
